import React from "react";
import { Calendar, ChevronDown, RefreshCw, Bell } from "lucide-react";

export function DashboardHeader({ onRefresh, refreshing, lastUpdated }) {
  return (
    <header className="flex items-center justify-between px-6 lg:px-8 py-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Dashboard</h1>
        <p className="text-sm text-slate-400 mt-0.5">Overview of HR Operations</p>
      </div>
    </header>
  );
}